"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lib = require("../lib");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var hookDefaultProps = {
  options: [],
  match: '',
  name: null,
  onChange: null,
  filter: function filter(match, string) {
    return string.substring(0, match.length).toLowerCase().includes(match.toLowerCase());
  }
};

var useFilter = function useFilter(props) {
  var hookProps = Object.assign(hookDefaultProps, props);

  var getFilterResult = function getFilterResult(options, match) {
    var filter = hookProps.filter;
    return options.filter(function (item, index, arr) {
      return filter(match, item, index, arr);
    });
  }; // initialise states


  var _useState = (0, _react.useState)(hookProps.match ? getFilterResult(hookProps.options, hookProps.match) : hookProps.options),
      _useState2 = _slicedToArray(_useState, 2),
      stateResult = _useState2[0],
      setResult = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      stateEvent = _useState4[0],
      setEvent = _useState4[1];

  var handleOnFilter = function handleOnFilter(e, match) {
    (0, _lib.callEventMethods)(e, 'persist', 'preventDefault');
    setEvent(e);
    var filter = hookProps.filter;

    if (filter) {
      var options = hookProps.options;
      var result = getFilterResult(options, match);
      setResult(result);
    }
  }; // setResult callback


  (0, _react.useEffect)(function () {
    var onChange = hookProps.onChange,
        name = hookProps.name;

    if (onChange) {
      onChange(stateEvent, {
        name: name,
        value: stateResult
      });
    }
  }, [stateResult]);

  var handleOnChange = function handleOnChange(e, p) {
    if ((0, _lib.objHasOwnProperty)(p, 'value')) {
      var value = p.value;
      handleOnFilter(e, value);
    }
  };

  return {
    onChange: handleOnChange,
    filter: handleOnFilter,
    getFilterResult: getFilterResult,
    result: stateResult,
    match: hookProps.match,
    options: hookProps.options
  };
}; // propTypes doesn't work for react hooks


useFilter.propTypes = {
  options: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object])),
  match: _propTypes["default"].string,
  name: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  filter: _propTypes["default"].func
};
var _default = useFilter;
exports["default"] = _default;